module.exports = __webpack_public_path__ + "img/copy-icon.35366259.svg";